<template>
  <v-tooltip
    v-if="label"
    location="bottom"
  >
    <template #activator="{ props: tooltipProps }">
      <v-btn
        icon
        elevation="1"
        size="x-small"
        rounded="circle"
        :class="btnClass"
        v-bind="{ ...$attrs, ...tooltipProps }"
      >
        <v-icon
          size="small"
          :color="iconColor"
          :class="iconClass"
        >{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ label }}</span>
  </v-tooltip>
  <v-btn
    v-else
    icon
    elevation="1"
    size="x-small"
    rounded="circle"
    :class="btnClass"
    v-bind="$attrs"
  >
    <v-icon
      size="small"
      :color="iconColor"
      :class="iconClass"
    >{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'BaseSidebarViewerBtn',

  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    btnClass: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
  },
};
</script>
